import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Alert, Badge, Button, Card, CardBody, CardHeader, Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";

import { adminPaths } from "admin/paths";
import AdminFormActions from "components/admin/AdminFormActions";
import AdminPageHeader from "components/admin/AdminPageHeader";
import { paymentPlanIds, subscriptionStatuses } from "data/admin/domain";
import { subscriptionsRepo } from "data/repositories/subscriptionsRepo";
import { usersRepo } from "data/repositories/usersRepo";
import EmptyState from "components/EmptyState";

export default function AdminSubscriptionDetail() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [error, setError] = useState("");
  const [refreshKey, setRefreshKey] = useState(0);
  void refreshKey;
  const subscription = subscriptionsRepo.getById(id);
  const user = subscription ? usersRepo.getById(subscription.userId) : null;

  const [form, setForm] = useState(() => ({ planId: subscription?.planId || "basic-monthly", status: subscription?.status || "active", startedAt: subscription?.startedAt || "", expiresAt: subscription?.expiresAt || "" }));

  React.useEffect(() => {
    setForm({ planId: subscription?.planId || "basic-monthly", status: subscription?.status || "active", startedAt: subscription?.startedAt || "", expiresAt: subscription?.expiresAt || "" });
  }, [subscription]);

  if (!subscription) {
    return (
      <>
        <div className="header bg-gradient-dark pb-6 pt-5 pt-md-7" />
        <Container className="mt--6" fluid>
          <EmptyState title="Abonelik bulunamadı" />
        </Container>
      </>
    );
  }

  const onSubmit = (event) => {
    event.preventDefault();
    setError("");
    try {
      subscriptionsRepo.update(subscription.id, form);
      navigate(`/admin${adminPaths.admin.subscriptions}`, { state: { status: { color: "success", message: "Abonelik güncellendi." } } });
    } catch (submitError) {
      setError(submitError?.message || "Abonelik güncellenemedi.");
    }
  };

  const toggleArchive = () => {
    if (subscription.deletedAt) subscriptionsRepo.restore(subscription.id);
    else subscriptionsRepo.remove(subscription.id);
    setRefreshKey((value) => value + 1);
  };

  return (
    <>
      <AdminPageHeader
        title="Abonelik detayı"
        description="Plan ve durum alanları mobile subscription modeliyle birebir uyumludur."
        backAction={() => navigate(`/admin${adminPaths.admin.subscriptions}`)}
      />

      <Container className="mt--6" fluid>
        <Row>
          <Col xl="8">
            <Card className="shadow">
              <CardHeader className="border-0"><h3 className="mb-0">Abonelik bilgileri</h3></CardHeader>
              <CardBody>
                {error ? <Alert color="danger">{error}</Alert> : null}
                <Form onSubmit={onSubmit}>
                  <FormGroup>
                    <Label>Kullanıcı</Label>
                    <Input value={`${user?.displayName || subscription.userId}${user?.email ? ` - ${user.email}` : ""}`} readOnly />
                  </FormGroup>
                  <FormGroup>
                    <Label>Plan</Label>
                    <Input type="select" value={form.planId} onChange={(event) => setForm((current) => ({ ...current, planId: event.target.value }))}>
                      {paymentPlanIds.map((plan) => <option key={plan} value={plan}>{plan}</option>)}
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label>Durum</Label>
                    <Input type="select" value={form.status} onChange={(event) => setForm((current) => ({ ...current, status: event.target.value }))}>
                      {subscriptionStatuses.map((status) => <option key={status} value={status}>{status}</option>)}
                    </Input>
                  </FormGroup>
                  <Row>
                    <Col md="6"><FormGroup><Label>Başlangıç</Label><Input value={form.startedAt} onChange={(event) => setForm((current) => ({ ...current, startedAt: event.target.value }))} /></FormGroup></Col>
                    <Col md="6"><FormGroup><Label>Bitiş</Label><Input value={form.expiresAt} onChange={(event) => setForm((current) => ({ ...current, expiresAt: event.target.value }))} /></FormGroup></Col>
                  </Row>
                  <AdminFormActions
                    saving={false}
                    onCancel={() => navigate(`/admin${adminPaths.admin.subscriptions}`)}
                    extraActions={
                      <Button color={subscription.deletedAt ? "success" : "danger"} className="ml-2" type="button" onClick={toggleArchive}>
                        {subscription.deletedAt ? "Geri al" : "Arşivle"}
                      </Button>
                    }
                  />
                </Form>
              </CardBody>
            </Card>
          </Col>
          <Col xl="4">
            <Card className="shadow">
              <CardHeader className="border-0"><h3 className="mb-0">Durum</h3></CardHeader>
              <CardBody>
                <Badge color={subscription.deletedAt ? "warning" : "success"} pill>{subscription.deletedAt ? "Arşivde" : "Aktif kayıt"}</Badge>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}